import { Dispatch } from 'redux'

import { PayrollPeriod } from '../../../../@paco/entities/PayrollPeriod/PayrollPeriod'

import { getIncludes } from '../../../../helpers/api/tracksApi'
import { getTracksToReviewInDateRange } from '../../../../helpers/api-ts/track'
import { TrackType } from '../../../../models'
import { setError, setIsLoading, setTracksToReview } from './tracksToReviewReducer'

export const fetchTracksToReview = (payrollPeriod: PayrollPeriod) => async (dispatch: Dispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    const { start, end } = payrollPeriod.period

    try {
        const response = await getTracksToReviewInDateRange(
            start,
            end,
            getIncludes(TrackType.review),
        )

        dispatch(setTracksToReview(response.data))
    } catch (error) {
        console.error('[fetchTracksToReview]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
